import { Drawer } from '@material-ui/core';
import { COLORS } from 'constants/design';
import styled from 'styled-components';
import { DropzoneAreaBase } from 'material-ui-dropzone';

export const DrawerContainer = styled(Drawer)`
  .MuiDrawer-paper {
    overflow-y: visible;
  }
  .MuiTimelineOppositeContent-root {
    flex: unset;
    padding: 0;
  }
  .MuiTimelineDot-root {
    color: rgba(84, 147, 189, 1);
    background-color: rgba(212, 236, 255, 1);
    box-shadow: unset;
    width: 12px;
    height: 12px;
  }
`;

export const StyledDropArea = styled(DropzoneAreaBase)`
  .MuiDropzoneArea-root {
    min-height: 150px !important;
  }
`;

export const DrawerDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: fit-content;
  min-width: 375px;

  .divider {
    width: 100%;
    background: ${COLORS.DEVIDER_GREY};
    height: 2px;
    min-width: 375px;
  }
  .titleConatainer {
    height: 64px;
    padding-left: 24px;
    padding-top: 23px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
  }
  .title {
    color: ${COLORS.BLUE};
    text-align: left;
    font-size: 15px;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    color: #0075c9;
    opacity: 1;
  }
  .actions {
    padding: 10px;
  }

  .action-buttons-container {
    padding: 0 10px;
  }

  .saveButton,
  .cancelButton {
    width: 126px;
    height: 36px;
  }

  .disabledSaveButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
  .content {
    overflow-y: scroll;
    height: 90%;
  }
`;
export const StyledCard = {
  padding: '16px 12px 16px 12px',
  color: '#FFFFFF',
  border: '1px solid #E0E4E9',
  borderRadius: '4px',
  width: '300px',
};

export const StyledTitle = {
  color: '#000000',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
};

export const StyledContainerCard = {
  backgroundColor: '#F3F5F7',
  padding: '10px 16px 10px 16px',
  width: '588.57px',
  minHeight: '702.3px',
};

export const ChipBody = {
  backgroundColor: '#FFF4E7',
  color: '#FF8C00',
  fontSize: '14px',
  borderRadius: '80px',
};
export const ChipDecision = {
  backgroundColor: '#EDFDEB',
  color: '#10BB00',
  fontSize: '14px',
  borderRadius: '80px',
  marginLeft: 2,
};

export const StyledPopper = {
  top: '81px',
  right: '303px',
  left: 'unset',
  marginTop: '5px',
  transform: 'translate3d(0px, 40px, 0px)',
  minWidth: '180px',
  zIndex: 100,
  backgroundColor: '#fafafa',
  boxShadow: '0px 2px 10px #00000033',
};
export const StyledMenuItem = {
  fontWeight: 400,
  fontSize: '14px',
  color: '#000000',
  borderBottom: '1.5px solid #D5DAE1',
};
export const StyledDiv = styled.div`
  width: 549px;
  display: flex;
  flex-direction: column;
  .input {
    margin-bottom: 20px;
    font-size: 13px;
  }
`;
export const StyledPrimaryButton = {
  backgroundColor: '#0075C9',
  padding: '8px 16px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  fontFamily: 'Roboto',
  color: '#FFF',
  textTransform: 'unset',
  borderRadius: '4px',
  border: '1px solid white',
};
